import React, { useState, useEffect } from 'react';
import { GetData } from '../utils/api';
import './FAQ.css';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const [faqsData, settingsData] = await Promise.all([
        GetData('/faqs'),
        GetData('/settings')
      ]);

      console.log('FAQs recibidas:', faqsData);

      // Agrupar FAQs por categoría
      const groupedFaqs = (faqsData.faqs || []).reduce((acc, faq) => {
        const category = faq.category || 'General';
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push({ 
          question: faq.question || '', 
          answer: faq.answer || '' 
        });
        return acc;
      }, {});

      // Convertir a formato de array y ordenar por categoría
      const faqsArray = Object.keys(groupedFaqs)
        .sort()
        .map(category => ({
        category,
        questions: groupedFaqs[category]
      }));

      console.log('FAQs agrupadas:', faqsArray);
      setFaqs(faqsArray);
      setSettings(settingsData.settings);
    } catch (error) {
      console.error('Error loading FAQs:', error);
      // Si hay error, usar array vacío en lugar de los FAQs hardcodeados
      setFaqs([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const index = `${categoryIndex}-${questionIndex}`;
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <div className="container">
        <div className="faq-header">
          <h1>Preguntas Frecuentes</h1>
          <p>Encuentra respuestas a las preguntas más comunes sobre nuestros productos y servicios</p>
        </div>

        <div className="faq-content">
          {faqs.length === 0 ? (
            <div className="no-faqs">
              <p>No hay preguntas frecuentes disponibles en este momento.</p>
              <p>Por favor, contacta a nuestro equipo de soporte si tienes alguna pregunta.</p>
            </div>
          ) : (
            faqs.map((category, categoryIndex) => (
            <div key={categoryIndex} className="faq-category">
              <h2 className="faq-category-title">{category.category}</h2>
              <div className="faq-list">
                  {category.questions && category.questions.length > 0 ? (
                    category.questions.map((item, questionIndex) => (
                  <div
                    key={questionIndex}
                    className={`faq-item ${openIndex === `${categoryIndex}-${questionIndex}` ? 'faq-item-open' : ''}`}
                  >
                    <button
                      className="faq-question"
                      onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                    >
                      <span>{item.question}</span>
                      <span className="faq-icon">
                        {openIndex === `${categoryIndex}-${questionIndex}` ? '−' : '+'}
                      </span>
                    </button>
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  </div>
                    ))
                  ) : (
                    <p>No hay preguntas en esta categoría.</p>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        <div className="faq-contact">
          <div className="faq-contact-card">
            <h3>¿No encontraste lo que buscabas?</h3>
            <p>Nuestro equipo de soporte está listo para ayudarte</p>
            <div className="faq-contact-buttons">
              <a href="/contact" className="btn btn-primary">
                Contactar Soporte
              </a>
              {settings?.contact?.phone && (
                <a href={`tel:${settings.contact.phone}`} className="btn btn-secondary">
                  {settings.contact.phone}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
